// extracted by mini-css-extract-plugin
export default {"TypeAheadInputWrapper":"typeAheadInput_TypeAheadInputWrapper_YJob9","TypeAheadInput":"typeAheadInput_TypeAheadInput_kXPfc"};